import React from "react";
import {
  StyledInputComponent,
  StyledInputOptional,
  StyledInputInputTitle,
  StyledInputWrapper,
  StyledInputRowWrapper,
  StyledInputInputError,
} from "./UI-Library.styles";

interface StyledInputProps extends React.DetailedHTMLProps<
  React.InputHTMLAttributes<HTMLInputElement>,
  HTMLInputElement
> {
  fieldTitle: string;
  error?: string;
  optional?: boolean;
}

export const StyledInput: React.FC<StyledInputProps> = ({
  fieldTitle,
  optional,
  error,
  ref,
  ...props
}) => (
  <StyledInputRowWrapper>
    <StyledInputWrapper>
      <StyledInputInputTitle>
        {`${fieldTitle} `}{" "}
        {optional && <StyledInputOptional>(optional)</StyledInputOptional>}
      </StyledInputInputTitle>
      <StyledInputComponent {...props} error={error} />
      {error && <StyledInputInputError>{error}</StyledInputInputError>}
    </StyledInputWrapper>
  </StyledInputRowWrapper>
);
